import type {
    MemberSignInFormCaptchaFieldProps,
    MemberSignInFormCheckboxFieldProps,
    MemberSignInFormInputFieldProps,
    MemberSignInFormProps as OCCMemberSignInFormProps,
} from '@vista-digital/occ-ui'
import { MemberSignInFormFieldName } from '@vista-digital/occ-ui'
import { defaultMemberSignInFormProps } from '@vista-digital/occ-ui/src/lib/components/member/sign-in-form/types/props'
import type { NestedPartial } from '@vista-digital/utilities'
import type { MemberSignInFormProps } from '@/common/components/signInForm/memberSignInForm/MemberSignInForm'
import type { MemberSignInFormPropsApi } from './models'

type MemberSignInFormPropsArgs = MemberSignInFormProps
export const memberSignInFormProps = (props: MemberSignInFormPropsArgs): NestedPartial<OCCMemberSignInFormProps> => {
    const { displayText, events } = props
    return {
        ...defaultMemberSignInFormProps,
        events,
        displayText: {
            submitButtonLabel: displayText.submitButtonLabel,
            cancelButtonLabel: displayText.cancelButtonLabel,
            errorApiIncorrectSignInCredentialsMessage: displayText.errorApiIncorrectSignInCredentialsMessage,
            errorApiMemberLockedMessage: displayText.errorApiMemberLockedMessage,
            errorApiFailedSignInMessage: displayText.errorApiFailedSignInMessage,
        },
    }
}

export const getIdentifierFieldProps = (props: MemberSignInFormPropsApi): MemberSignInFormInputFieldProps => {
    return {
        name: MemberSignInFormFieldName.Identifier,
        displayText: {
            label: props.emailLabel,
            placeholder: props.emailLabel,
            requiredMessage: props.emailRequiredMessage,
        },
    }
}

export const getPasswordFieldProps = (props: MemberSignInFormPropsApi): MemberSignInFormInputFieldProps => {
    return {
        name: MemberSignInFormFieldName.Password,
        displayText: {
            label: props.passwordLabel,
            placeholder: props.passwordLabel,
            requiredMessage: props.passwordRequiredMessage,
        },
    }
}

export const getRememberFieldProps = (props: MemberSignInFormPropsApi): MemberSignInFormCheckboxFieldProps => {
    return {
        name: MemberSignInFormFieldName.Remember,
        displayText: {
            label: props.rememberMeLabel,
            requiredMessage: '',
        },
    }
}

export const getCaptchFieldProps = (props: MemberSignInFormPropsApi): MemberSignInFormCaptchaFieldProps => {
    return {
        name: MemberSignInFormFieldName.Captcha,
        displayText: {
            requiredMessage: props.captchaRequiredMessage,
        },
    }
}
